import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 5C16.1 5 16.2 5 16.3 5.1L18 6.8C19.3 8.1 20.1 9.9 20.1 11.7V13C20.1 16.3 17.4 19 14.1 19H10.1C6.8 19 4.1 16.3 4.1 13V12C4.1 10.7 4.7 9.6 5.7 8.8C6.3 8.3 7.1 8 8 8H9.3C9.8 8 10.3 8.2 10.7 8.6L10.8 8.7C11.4 9.3 12.1 9.6 12.9 9.6C14.6 9.6 15.9 8.3 15.9 6.6L16 5ZM16 3C14.9 3 14 3.9 14 5V6.6C14 7.2 13.5 7.6 13 7.6C12.8 7.6 12.5 7.5 12.3 7.3L12.2 7.2C11.4 6.4 10.4 6 9.3 6H8C6.7 6 5.4 6.4 4.4 7.2C2.9 8.3 2 10.1 2 12V13C2 17.4 5.6 21 10 21H14C18.4 21 22 17.4 22 13V11.7C22 9.3 21.1 7 19.4 5.3L17.7 3.6C17.3 3.3 16.6 3 16 3ZM7.5 13C6.7 13 6 12.3 6 11.5C6 10.7 6.7 10 7.5 10C8.3 10 9 10.7 9 11.5C9 12.3 8.3 13 7.5 13ZM9.5 17C8.7 17 8 16.3 8 15.5C8 14.7 8.7 14 9.5 14C10.3 14 11 14.7 11 15.5C11 16.3 10.3 17 9.5 17ZM14.5 17C13.7 17 13 16.3 13 15.5C13 14.7 13.7 14 14.5 14C15.3 14 16 14.7 16 15.5C16 16.3 15.3 17 14.5 17ZM16.5 13C15.7 13 15 12.3 15 11.5C15 10.7 15.7 10 16.5 10C17.3 10 18 10.7 18 11.5C18 12.3 17.3 13 16.5 13Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgPaletteOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgPaletteOutline;
